import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {Form, FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Patient} from '../../../patient';
import {PatientService} from '../../../../../services/service.index';
import {NgbModal, NgbModalConfig} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-patient-form',
  templateUrl: './patient-form.component.html',
  styleUrls: ['./patient-form.component.css']
})
export class PatientFormComponent implements OnInit {

  constructor(private patientService: PatientService, private fb: FormBuilder,
              private config: NgbModalConfig, private modalService: NgbModal) {
    this.formCreate();
    // customize default values of modals used by this component tree
    config.backdrop = 'static';
    config.keyboard = false;
  }

  @Output() private selectedPatient = new EventEmitter<Patient>();
  patient: FormGroup;
  newPatient: FormGroup;
  patients;

  ngOnInit(): void {
  }
  formCreate() {
    this.patient = this.fb.group({
      name: ['', ],
      surname: ['', ],
      fiscalCode: ['', ]
    });
  }
  formNewPatientCreate() {
    this.newPatient = this.fb.group({
      name: [this.patient.get('name').value, Validators.required],
      surname: [this.patient.get('surname').value, Validators.required],
      fiscalCode: [this.patient.get('fiscalCode').value, Validators.required],
      healthCode: ['', ],
      sex: ['', ],
      birthdate: ['', ],
      address: ['', ],
      phone: ['', ],
      email: ['', Validators.email]
    });
  }
  searchPatient(patientsModal, patientCreateModal) {
    this.patientService.getPatient(this.patient)
      .subscribe( (patients: Patient) => {
        if ( patients !== null && Object.keys(patients).length > 0) {
          if (Object.keys(patients).length > 1) {
            this.patients = patients;
            this.openModal(patientsModal);
          } else {
            this.patientSelected(patients[0]);
          }
        } else {
          this.formNewPatientCreate();
          this.openModal(patientCreateModal);
          console.log('MODAL PARA CREAR PACIENTE');
        }
      });
  }
  createPatient() {
    this.selectPatient(this.newPatient.value);
  }
  patientSelected(patient) {
    this.selectedPatient.emit(patient);
  }
  selectPatient(patient: Patient) {

    this.patientSelected(patient);
    this.closeModal();
  }
  openModal(content) {
    this.modalService.open(content, {size: 'lg', backdrop: 'static'});
  }
  closeModal() {
    this.modalService.dismissAll();
  }
}
